import { useEffect, type ReactNode } from 'react';
import { PLATFORM_TOOL_CATALOG } from '@autonomous-team/domain';

export interface ToolAccessValue {
  readonly toolMode: 'default' | 'custom';
  readonly toolAllow: readonly string[];
  readonly toolDeny: readonly string[];
}

export function ToolAccessEditor<T extends ToolAccessValue>({ value, defaultTools, mcpSources = [], onChange }: {
  readonly value: T;
  readonly defaultTools?: readonly string[] | undefined;
  readonly mcpSources?: readonly string[];
  readonly onChange: (next: T) => void;
}): ReactNode {
  const grants = [
    ...PLATFORM_TOOL_CATALOG.map((tool) => ({ id: `platform:${tool.id}`, label: tool.id, group: tool.group })),
    ...mcpSources.map((id) => ({ id: `mcp:${id}/*`, label: `${id} — all tools`, group: 'MCP servers' })),
  ];
  const groups = [...new Set(grants.map((grant) => grant.group))];
  const materializedDefaults = [...new Set([...(defaultTools ?? []), ...mcpSources.map((id) => `mcp:${id}/*`)])];
  useEffect(() => {
    if (value.toolMode === 'default' && defaultTools !== undefined) onChange({ ...value, toolMode: 'custom', toolAllow: materializedDefaults });
  }, [value, onChange, materializedDefaults]);
  const toggle = (id: string, checked: boolean): void => onChange({ ...value, toolAllow: checked ? [...value.toolAllow, id] : value.toolAllow.filter((entry) => entry !== id) });
  return <section className="tool-access-editor" aria-label="Tool access">
    <div className="tool-access-heading"><div><h4>Tools</h4><p>Explicit access list. Every checked tool is saved with this agent.</p></div></div>
    <div className="tool-access-groups">{groups.map((group) => <fieldset key={group}><legend>{group}</legend><div className="tool-grant-grid">{grants.filter((grant) => grant.group === group).map((grant) => <label className="tool-grant-row" key={grant.id}><input type="checkbox" checked={(value.toolMode === 'default' ? materializedDefaults : value.toolAllow).includes(grant.id)} onChange={(event) => toggle(grant.id, event.target.checked)} /><span>{grant.label}</span></label>)}</div></fieldset>)}{mcpSources.length === 0 ? <p className="hint">Connect an MCP server below to make its tools available here.</p> : null}</div>
  </section>;
}
